<bw-section-card-legacy [header]="'LOAN_MENU_LENDER_DETAILS_SECTION_HEADER' | translate">
  <ng-template #wrappedContent>
    <bw-cell-legacy
      [labelSubLeft]="'LOAN_MENU_LENDER_NAME' | translate"
      [labelSubRight]="loan.partner?.displayName"
      leftLabelColor="--secondary-text"
      [separatorType]="'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      [labelSubLeft]="'LOAN_MENU_PHONE_NUMBER' | translate"
      [labelSubRight]="loan.partner?.phoneNumber | phone"
      iconNameRight="phone"
      iconRightMargin="ml-xs"
      leftLabelColor="--secondary-text"
      [separatorType]="'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      [labelSubLeft]="'LOAN_MENU_CLIENT_LOGIN' | translate"
      [labelSubRight]="'LOAN_CLIENT_PARTNER_LOGIN' | translate : { partnerName: loan.partner?.displayName }"
      iconNameRight="chevron_right"
      iconRightMargin="ml-xs"
      leftLabelColor="--secondary-text"
      [separatorType]="'none'"
      (clicked)="onPartnerLinkClick(loan.partner?.link, loan.partner?.displayName)"
    >
    </bw-cell-legacy>
  </ng-template>
</bw-section-card-legacy>
